import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreatePromoCodeDiscount = () => {
  return (
    <Create
      title='Link Discount to Promo Code'
      fields={fields}
      apiPath='admin/promo_code_discounts'
      successRedirectPath='/ecommerce/promo-code-discounts'
      buildMenuItems={menuItems}
    />
  )
}

export default CreatePromoCodeDiscount
